import React from "react";
import {Navigate} from "react-router-dom";
import {isShopEnabled} from "../utility/featureFlags";

const ShopRouteGuard = ({children}) => isShopEnabled() ? children : <Navigate to="/" replace/>;

export default ShopRouteGuard;
